import Crud from '../views/Device/Crud'
import Entity from '../views/Device/Detail'

let routes = {
    path: '/devices',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/devices/edit/:id?',
            name: 'EditDevice',
            component: Entity
        },
        {
            path: '/devices',
            name: 'list-devices',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Dispositivos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
